/* Mr Bargain: sort size filter values numerically (e.g. EU 42/43 sits between 42 and 43) */
(function () {
  function sizeKey(text) {
    var t = (text || '').replace(/\(\s*\d+\s*\)\s*$/, '').trim();
    var m = t.match(/(\d+(?:\.\d+)?)(?:\s+(\d+)\/(\d+))?(?:\s*[\/\-]\s*(\d+(?:\.\d+)?))?/);
    if (!m) return Infinity;
    var n = parseFloat(m[1]);
    if (m[2] && m[3]) n += parseFloat(m[2]) / parseFloat(m[3]);
    if (m[4]) n = (n + parseFloat(m[4])) / 2;
    return n;
  }
  function labelText(li) {
    var label = li.querySelector('label');
    if (!label) return '';
    var clone = label.cloneNode(true);
    var count = clone.querySelector('.filter-count');
    if (count) count.remove();
    return clone.textContent;
  }
  function sortSizeFilters() {
    var groups = document.querySelectorAll('#FiltersForm .yv-filter-name');
    Array.prototype.forEach.call(groups, function (group) {
      var title = group.querySelector('.yv-filter-title');
      if (!title || !/size/i.test(title.textContent)) return;
      var content = group.querySelector('.yv-filter-content');
      if (!content || content.dataset.mbSorted) return;
      var lists = content.querySelectorAll('ul.yv-filter-content-list');
      if (!lists.length) return;
      var main = lists[0];
      var more = content.querySelector('ul.more-options');
      var limit = main.children.length;
      var items = Array.prototype.slice.call(content.querySelectorAll('li.yv-filter-item'));
      var keyed = items.map(function (li, i) { return { li: li, k: sizeKey(labelText(li)), i: i }; });
      if (keyed.every(function (o) { return o.k === Infinity; })) { content.dataset.mbSorted = '1'; return; }
      keyed.sort(function (a, b) { return (a.k - b.k) || (a.i - b.i); });
      keyed.forEach(function (o, idx) {
        (idx < limit || !more ? main : more).appendChild(o.li);
      });
      content.dataset.mbSorted = '1';
    });
  }
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; sortSizeFilters(); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortSizeFilters);
  } else {
    sortSizeFilters();
  }
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();
